/**
 * A user's User ID (z8nrz7e46f): the part of their email before the `@`, so
 * `shalom267@gmail.com` is `shalom267`. Assigned by the server, which numbers
 * it (`john-2`) when another domain already holds the plain one — so this is a
 * PREVIEW of the likely ID, never the authority on it.
 *
 * Mirrors cgt-backend src/users/user-id.ts (`userIdBase`) — keep in sync.
 */
export function userIdFromEmail(email: string): string {
  const trimmed = email.trim().toLowerCase()
  if (!trimmed.includes('@')) return ''
  return trimmed.split('@')[0] || 'user'
}
